module.exports = __webpack_public_path__ + "static/media/background3.cad0ef14.jpg";